import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { withTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./productionOrderSapFilter.data.form";
import InputSelect from "../../../utils/InputSelect";
import InputDate from "../../../utils/InputDate";
import InputText from "../../../utils/InputText";
import { POSAP_STATUS } from "../../../../constants";

const ProductionOrderSapFilterForm = (props) => {
  const { t, handleSubmit, filtered, onClean } = props;

  const loadData = async () => {
    // TODO: ??
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="row no-margin">
      <div className="accordion-item border rounded">
        <div className="col-12 mb-3">
          <div className="accordion-body mt-3">
            <form
              className="form-horizontal"
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              {/* sapDateStart */}
              <div className="row">
                <div className="col-3">
                  <Field
                    id="sapDateStartInit"
                    labelField={t(
                      "forms.productionOrderSap.labels.sapStartDateInit",
                    )}
                    className="form-control"
                    name="sapDateStartInit"
                    component={InputDate}
                    language="es"
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
                <div className="col-3">
                  <Field
                    id="sapDateEnd"
                    labelField={t(
                      "forms.productionOrderSap.labels.sapStartDateEnd",
                    )}
                    className="form-control"
                    name="sapDateEnd"
                    component={InputDate}
                    language="es"
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
                <div className="col-3">
                  <Field
                    id="sapQuantity"
                    className="form-control"
                    labelField={t(
                      "forms.productionOrderSap.labels.sapQuantity",
                    )}
                    name="sapQuantity"
                    component={InputText}
                    fieldType="text"
                    placeholder=""
                  />
                </div>
                <div className="col-3">
                  <Field
                    id="idOrderSap"
                    className="form-control"
                    labelField={t("forms.productionOrderSap.labels.idOrderSap")}
                    name="idOrderSap"
                    component={InputText}
                    fieldType="text"
                    placeholder=""
                  />
                </div>
                <div className="col-3">
                  <Field
                    id="status"
                    name="status"
                    labelField={t("forms.productionOrderSap.labels.status")}
                    component={InputSelect}
                    optionLabel="label"
                    optionValue="code"
                    options={POSAP_STATUS.map((item) => ({
                      ...item,
                      label: t(item.label),
                    }))}
                    placeholder=""
                    classNamePrefix="dark"
                    addOptionEmpty
                    classNameContainer="flex-grow-1"
                  />
                </div>
                <div className="row justify-content-center no-margin ">
                  <div className="form-check form-switch mt-3">
                    <Field name="showNotificated">
                      {({ field }) => (
                        <input
                          {...field}
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="showNotificated"
                          checked={field.value}
                        />
                      )}
                    </Field>
                    <label
                      className="form-check-label"
                      htmlFor="showNotificated"
                    >
                      {t("forms.productionOrderSap.labels.showNotificated")}
                    </label>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12 d-flex justify-content-end">
                  <button type="submit" className="btn btn-lg btn-primary me-2">
                    <i className="fas fa-search"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-lg btn-secondary"
                    onClick={() => onClean(props.resetForm)}
                    title={t("cleanFilter")}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

ProductionOrderSapFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  filtered: PropTypes.bool,
  onClean: PropTypes.func,
};

const ProductionOrderSapFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "OrderFilterForm",
})(withTranslation()(ProductionOrderSapFilterForm));

export default ProductionOrderSapFilterFormF;
